import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NewsFeedLiveComponent from './js/news-feed-live.component';

ComponentsFactory.getInstance().define('news-feed-live', NewsFeedLiveComponent);
